import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer id="footer" className="footer dark-background">
        <div className="footer-top">
          <div className="container">
            <div className="row gy-4">
              <div className="col-lg-2 col-md-3 footer-links">
                <h4>About IPDA</h4>
                <p className="">
                  Indo Pulses Development Association (IPDA) is dedicated to
                  enhancing the efficiency of the pulses value chain across
                  India.
                </p>
              </div>

              <div className="col-lg-2 col-md-3 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="about-csc">About us</a>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                  {/* <li>
                    <a href="#">Services</a>
                  </li> */}
                  {/* <li>
                    <a href="#">Privacy policy</a>
                  </li> */}
                </ul>
              </div>
              {/* <div className="col-lg-2 col-md-3 footer-links">
                <h4>Our Services</h4>
                <ul>
                  <li>
                    <a href="#">Web Design</a>
                  </li>
                  <li>
                    <a href="#">Web Development</a>
                  </li>
                  <li>
                    <a href="#">Product Management</a>
                  </li>
                  <li>
                    <a href="#">Marketing</a>
                  </li>
                  <li>
                    <a href="#">Graphic Design</a>
                  </li>
                </ul>
              </div> */}
              <div className="col-lg-4 col-md-6 footer-about">
                <a href="index.html" className="logo d-flex align-items-center">
                  <span className="sitename">
                    Indo Pulses Development Association (IPDA)
                  </span>
                </a>
                <div className="footer-contact pt-3">
                  <p>
                    3701 Tuljapur Khurad, Tuljapur, Osmanabad, Maharashtra,
                    India, 413601
                  </p>
                  <p className="mt-3">
                    <strong>Phone:</strong> <span>+91 98226 06267</span>
                  </p>
                  <p>
                    <strong>Email:</strong>{" "}
                    <span>publicrelation@ipda.in, smart.tspcsc@in.gt.com</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright text-center">
          <div className="container d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center">
            <div className="d-flex flex-column align-items-center align-items-lg-start">
              <div>
                © Copyright{" "}
                <strong>
                  <span style={{ color: "#d4561a" }}>IPDA</span>
                </strong>
                . All Rights Reserved
              </div>
            </div>
            <div className="social-links order-first order-lg-last mb-3 mb-lg-0">
              <a href="" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-twitter-x" />
              </a>
              <a href="" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-facebook" />
              </a>
              <a href="" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram" />
              </a>
              <a
                href="https://www.linkedin.com/company/indo-pulses-development-association-ipda/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-linkedin" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
